import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import { dateHourMinuteFormatInTimezone } from "src/utils/timezoneFormat";
import { UserActionMenu } from "./UserActionMenu";

const dateFormat = "yyyy-MM-dd hh:mm a";

export const userListColumns = (isReadOnly, timeZone)=>([
  {
    field: "username",
    headerName: "Username",
    flex: 1,
    minWidth:150,
    resizable: true,
    renderCell: ({ value, id }) => (<>
      {isReadOnly ?value:<Link underline="none" component={RouterLink} to={`${id}`}>
        {value}
      </Link>}
    </>
    ),
  },
  {
    field: "firstName",
    headerName: "First Name",
    flex: 1,
    minWidth:100,
    resizable: true,
  },
  {
    field: "lastName",
    headerName: "Last Name",
    flex: 1,
    minWidth:100,
    resizable: true,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1.2,
    minWidth:220,
    resizable: true,
    renderCell:({value})=>(
      <Tooltip title={value} placement="top"><span>{value}</span></Tooltip>
    )
  },
  {
    field: "createDate",
    headerName: "Created on",
    type: "date",
    flex: 1,
    minWidth:180,
    resizable: true,
    valueFormatter: ({ value }) => {
      return timeZone
        ? dateHourMinuteFormatInTimezone(value, timeZone)
        : fDateTime(value, dateFormat);
    },
  },
  {
    field: "Actions",
    width: 70,
    sortable: false,
    renderCell: UserActionMenu,
  },
]);

export const getUserDefaultValues = () => ({
  userId: "",
  username: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  // canAccessParent: false,
  // roleId: ""
});
